import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '../lib/utils';
import { MIN_TOUCH_TARGET_PX } from './button';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  /** Marca o campo como inválido — some borda de erro e `aria-invalid` para leitores de tela. */
  invalid?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'flex w-full rounded-md border bg-surface-2 px-4',
        `min-h-[${MIN_TOUCH_TARGET_PX}px]`,
        'font-sans text-[length:var(--t-base)] text-ink-1 placeholder:text-ink-4',
        'transition-colors duration-1 ease-soberano',
        'focus-visible:border-gold focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-gold/[0.16]',
        'disabled:cursor-not-allowed disabled:opacity-40',
        invalid ? 'border-danger' : 'border-[color:var(--hairline)]',
        className,
      )}
      {...props}
    />
  ),
);

Input.displayName = 'Input';
